import { Route } from '@angular/router';
import { ModalHeaderLocationGuard } from '@nx/mono-common';
import { UserSignedInGuard } from './user-signed-in.guard';
import * as signInRoutes from '../../sign-in/routing/route-locales/sign-in-routes';
import  * as registrationRoutes  from '../../registration/routing/route-locales/registration-routes'


export const registrationState: Route = {
  path: registrationRoutes.registrationLazyLoaded.path,
  loadChildren: () => import ('../../registration/registration.module').then(mod => mod.RegistrationModule)
}

export const signInState: Route = {
  path: signInRoutes.signInLazyLoaded.path,
  loadChildren: () => import ('../../sign-in/sign-in.module').then(mod => mod.SignInModule)
}

export const userRootState = {
  path: '',
  canActivate: [ModalHeaderLocationGuard, UserSignedInGuard],
  children: [
    registrationState,
    signInState
  ]
}

export const AppStates = [userRootState]
